import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Icon from './Icon';

export default ({ show, onClose, children, title, ignoreClose }) => {
  const modalRef = useRef();
  const downClickRef = useRef();
  const notiflixPresent = () =>
    document.querySelector('.notiflix-confirm-content') ||
    document.querySelector('.notiflix-report');

  useEffect(() => {
    const handleUpClick = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        downClickRef.current &&
        !notiflixPresent()
      ) {
        // watch for clicks outside of modal wrapper element
        // but ignore clicks to confirmations / alerts

        onClose();
      }
    };
    const handleDownClick = (event) => {
      if (modalRef.current && !notiflixPresent()) {
        // watch for clicks outside of modal wrapper element
        // but ignore clicks to confirmations / alerts
        downClickRef.current = !modalRef.current.contains(event.target);
      }
    };

    if (ignoreClose) {
      document.removeEventListener('mousedown', handleDownClick, true);
      document.removeEventListener('mouseup', handleUpClick, true);
    } else {
      document.addEventListener('mousedown', handleDownClick, true);
      document.addEventListener('mouseup', handleUpClick, true);
    }
    return () => {
      document.removeEventListener('mousedown', handleDownClick, true);
      document.removeEventListener('mouseup', handleUpClick, true);
    };
  }, [ignoreClose]);

  return createPortal(
    <>
      {show && (
        <div className='modal-dialog'>
          <div className={'modal-content' + ` ${title}`} ref={modalRef}>
            {children}
            <Icon icon='times-circle' onClick={onClose} />
          </div>
        </div>
      )}
    </>,
    document.getElementById('modal-wrapper')
  );
};
